/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2026
///                                     RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";

import ErrorIcon from "../../components/icons/ErrorIcon";
import BannerInfo from "../Bid/BannerInfo";
import { hideBanner } from "../../slices/bidSummarySlice";
import messages from "../../helpers/messages";

export const Banner = ({
  pageContainerClass,
  isLaneImportInProgress,
  isLaneRepriceInProgress,
  isCapacityMatchingInProgress,
  repriceReason
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.user);
  const { summaryLoading, summaryError, summary, showBanner } = useSelector(
    state => state.bidSummary
  );
  const { enableInternalCapacityMatching } = useSelector(
    state => state.featureFlags
  );
  const isUploadOrPricingInProgress =
    isLaneImportInProgress || isLaneRepriceInProgress;

  return (
    <Fragment>
      {showBanner && (
        <div
          className={`h-52 one-whole inline-block bg-white ${
            isUploadOrPricingInProgress
              ? "banner-in-progress"
              : "border-bottom-grey"
          } ${summaryLoading || summaryError ? "mt-6" : ""}`}
        >
          {summaryLoading && (
            <div
              className={`content-placeholder py-20 ${
                pageContainerClass ? "page-container" : "px-24"
              }`}
            >
              <span style={{ width: "632px" }}></span>
            </div>
          )}
          {summaryError && (
            <div
              className={`banner-bid-error ${
                pageContainerClass ? "page-container" : "px-24"
              }`}
            >
              <ErrorIcon
                className="pos-relative inline-block error-icon"
                height="20px"
                width="20px"
                fill="#B00020"
              />
              <span
                data-testid="error-message"
                className="pl-8 inline-block mt-16 text-light-grey font-size-14 text-rfq-red"
              >
                {messages.pleaseRefreshTheBrowser.defaultMessage}
              </span>
            </div>
          )}
          {summary && (
            <>
              <div
                id="banner"
                data-testid="info-banner"
                className={`${pageContainerClass ? "page-container" : "px-24"}`}
              >
                <BannerInfo
                  summary={summary}
                  user={user}
                  hideBanner={() => dispatch(hideBanner())}
                  isLaneImportInProgress={isLaneImportInProgress}
                  isLaneRepriceInProgress={isLaneRepriceInProgress}
                  isCapacityMatchingInProgress={isCapacityMatchingInProgress}
                  repriceReason={repriceReason}
                  enableInternalCapacityMatching={
                    enableInternalCapacityMatching
                  }
                />
              </div>
            </>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default Banner;
